import React from 'react';
import { Outlet } from 'react-router';
import { useLocation } from 'react-router-dom';

import { PATH } from '~/constants';

import styles from './LoginLayout.module.scss';

const LoginLayout = () => {
  const location = useLocation();
  const isLogin = location.pathname === PATH.LOGIN;

  return (
    <div
      className={`
        ${isLogin ? styles['login-page-background'] : styles['default-background']}
        ${styles['layout-container']}
      `}
    >
      <Outlet />
    </div>
  );
};

export default LoginLayout;
